import React = require('react');
import { AdmiralCardAnswer } from '../../../Components/AdmiralCardAnswer';
import { Button, Col, Row } from 'react-bootstrap';
import { Field, InjectedFormProps } from 'redux-form';
import { isRequired, mustBeFalse } from '../../../../../../util/validators';
import { ButtonAsRadio } from '../../../../../../components/ButtonRadioStyle';
import { useEffect, useState } from 'react';
import { get, isNull } from 'lodash';
import { IOptionMap } from '../../../../../../data/api/models';
import { DeclineModal } from '../ImportantStatements/DeclineModal';
import { Collapsable, ICollapsableComponent } from '../../../../../../services/quote/models';
import { setCollapsable } from '../../../../../../services/quote/reducer';

interface IHazardousActivitiesProps extends InjectedFormProps {
  options: IOptionMap;
  synchronousError: any;
  wordingUrl: string;
  valid?: boolean;
  dispatch?: any;
  collapsable?: ICollapsableComponent
}

export const HazardousActivities = ({
                                      options,
                                      change,
                                      wordingUrl,
                                      dispatch,
                                      collapsable,
                                      valid = true,
                                      ...props
                                    }: IHazardousActivitiesProps) => {

  const [editable, setEditable] = useState(true);
  const [showDeclineModal, setShowDeclineModal] = useState(false);

  const onChangeCollapse = () => {
    dispatch(setCollapsable(null, Collapsable.HAZARDOUS_ACTIVITIES));
  }

  useEffect(() => {
    if (props.isDirectquoteRetrieval && get(options, 'hazardous_activities') === null) {
      change('options.hazardous_activities', false)
    }
  }, []);

  useEffect(() => {
    if (get(options, 'hazardous_activities') === false || get(options, 'hazardous_activities') === true) {
      setEditable(false)
    }
  }, [get(options, 'hazardous_activities')]);

  const onChangeEdit = (isEditable) => {
    setEditable(isEditable)
    change('options.hazardous_activities', null);
  }

  const handleAnswerChange = (value) => {
    if (value) {
      setShowDeclineModal(true)
    }
    setEditable(false)
  }

  const closeModal = () => {
    setShowDeclineModal(false);
  }

  const renderModalBody = () => {
    return (
      <div style={{ padding: '15px 0 15px 0' }}>
        <div>We need to check some details.</div>
        <ul style={{ textAlign: 'left' }}>
          <li>Please check the policy <a href={wordingUrl} target={'_blank'}>wording</a> to see if your
            activity is covered?
          </li>
          <li>Call our customer services on 0333 234 9913 as this may need to be checked by our Underwriting team before
            acceptance.
          </li>
        </ul>
      </div>
    )
  }

  const content = () => {
    return (
      <Row>
        <Col xs={12}>Do any named travellers intend on doing any activities that may be considered hazardous or
          dangerous?</Col>
      </Row>
    )
  }

  const handleContinue = () => {
    dispatch(setCollapsable(Collapsable.HAZARDOUS_ACTIVITIES, null));
  }

  const renderContinueButton = () => {
    return (
      <Row style={{ padding: '15px' }}>
        <Col xs={12}>
          <Button
            bsSize={'small'}
            type="button"
            block={true}
            disabled={!valid}
            onClick={handleContinue}
            className={'admiral-primary-btn'}>
            CONTINUE
          </Button>
        </Col>
      </Row>
    )
  }

  const renderButtons = () => {
    return (
      <>
        <div className={'button-container'}>
          <div className={'box--half'}>
            <Field
              name={'options.hazardous_activities'}
              simpleValue={true}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn'}
              selectedText={'YES'}
              unSelectedText={'YES'}
              isBlock={true}
              validate={[isRequired, mustBeFalse]}
              component={ButtonAsRadio}
              handleChange={handleAnswerChange}
            />
          </div>
          <div className={'box--half'}>
            <Field
              name={'options.hazardous_activities'}
              simpleValue={false}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn'}
              selectedText={'NO'}
              unSelectedText={'NO'}
              isBlock={true}
              validationMessage={'single'}
              validate={[isRequired, mustBeFalse]}
              component={ButtonAsRadio}
              handleChange={handleAnswerChange}
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <AdmiralCardAnswer
        icon={'warning-white.svg'}
        title={'Hazardous Activities'}
        editMode={editable}
        handleEdit={onChangeEdit}
        answerSelected={get(options, 'hazardous_activities')}
        approvedPositiveText={'None of the travellers intend on doing hazardous activities'}
        approvedNegativeText={'Yes, one or more of the travellers intend on doing hazardous activities'}
        reverseDisplayAnswers={true}
        collapsable={collapsable?.hazardousActivities}
        continueButton={collapsable && renderContinueButton}
        handleCollapse={onChangeCollapse}
      >
        {content()}
        <div style={{ backgroundColor: '#FFFFFF' }}>
          {editable && renderButtons()}
          <div>
            <DeclineModal
              showDeclineModal={showDeclineModal}
              title={'All Hazardous activities must be added to a policy in order to be covered.'}
              closeButtonText={'RETURN TO QUOTE'}
              body={renderModalBody()}
              onCloseModal={closeModal}/>
          </div>
        </div>
      </AdmiralCardAnswer>
    </>
  )
}
